import PropTypes from 'prop-types';

export const trialBalancePropTypes = PropTypes.shape({
  PERIOD_NAME: PropTypes.string,
  COMPANY_CODE: PropTypes.string,
  LOCAL_ACCOUNT: PropTypes.string,
  CHART_NAME: PropTypes.string,
  LOCAL_ACCOUNT_DESCRIPTION: PropTypes.string,
  YTD_BALANCE: PropTypes.string,
  CURRENCY_CODE: PropTypes.string,
  IMPORT_VALIDATION: PropTypes.string,
  IMPORT_STATUS_DETAIL: PropTypes.string,
  R_2_R_ACCOUNT: PropTypes.string,
  R_2_R_DESCRIPTION: PropTypes.string,
  BOOK_TYPE: PropTypes.string,
  COST_CENTER: PropTypes.string,
  GEOGRAPHY: PropTypes.string,
  PROJECT: PropTypes.string,
  REFERENCE: PropTypes.string,
  TRADING_PARTNER: PropTypes.string,
  PRODUCT_LINE: PropTypes.string,
  ENTERED_AMOUNT: PropTypes.string,
  ENTERED_CURRENCY_CODE: PropTypes.string,
});
